// src/pages/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { getSupervisors } from '../../services/supervisors';
import { getDriverAttendance as getDA, getDashboard, getDrivers } from '../../services/drivers';
import { USER_ID, USER_TYPE } from '../../api/axios';

const Dashboard = () => {
  const [isAdmin, setIsAdmin] = useState(true);
  const [sCount, setSCount] = useState(0);
  const [dCount, setDCount] = useState(0);
  const [daCount, setDACount] = useState(0);
  const [supervisors, setSupervisors] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selSupervisor, setSelSupervisor] = useState('');
  const [selDriver, setSelDriver] = useState('');
  const [frmDate, setFrmDate] = useState(() => {
    return new Date().toISOString().split('T')[0];
  });
  const [attendanceData, setAttendanceData] = useState(null);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    // Example calls, update with real endpoints
    const currentUser = sessionStorage.getItem(USER_TYPE);
    const isAdminUser = currentUser.toLowerCase() === 'admin';
    const userId = sessionStorage.getItem(USER_ID);
    setIsAdmin(isAdminUser);
    fetchCounts();
    if (isAdminUser) {
      fetchSupervisors();
    } else {
      fetchDrivers(userId);
    }
    // fetchDrivers();
  }, []);

  const fetchCounts = async () => {
    // Replace with real API
    setSCount(supervisors.length);
    setDCount(drivers.length);
    try {
      const res = await getDashboard();
      //setAttendanceData(res);
      setSCount(res.supervisors);
      setDCount(res.drivers);
      setDACount(res.online_drivers);
      // setFileList(res.files || []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchSupervisors = async () => {
    // Example
    try {
      const res = await getSupervisors();
      setSupervisors(res || []);
      if (res.length > 0 && res[0].user?.id) {
        const firstId = res[0].user.id;
        setSelSupervisor(firstId); // ✅ auto-select
        fetchDrivers(firstId); // ✅ auto-fetch drivers
      }
    } catch (err) {
      setSupervisors([]); // fallback to avoid undefined
    }
  };

  const handleSupervisorChange = async e => {
    const selectedId = e.target.value;
    if (!selectedId || selectedId === '') {
      console.log('No valid supervisor selected yet');
      return;
    }
    setSelSupervisor(selectedId);
    console.log(selSupervisor);
    if (selectedId) {
      fetchDrivers(selectedId);
    } else {
      setDrivers([]);
    }
  };

  const fetchDrivers = async supervisorId => {
    setDrivers([]);
    try {
      if (!supervisorId) return;

      const res = await getDrivers(supervisorId);
      setDrivers(res || []);
    } catch (error) {
      setDrivers([]); // fallback to empty list
    }
  };

  const getDriverAttendance = async () => {
    try {
      const res = await getDA(selDriver, frmDate);
      setAttendanceData(res);
      // setFileList(res.files || []);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="container-fluid mt-3">
      {/* Counts */}
      <div className="row">
        {isAdmin && (
          <div className="col-lg-3 col-sm-6 mb-3">
            <div className="p-3 bg-light border rounded shadow-sm text-center">
              <h4>{sCount}</h4>
              <p>Supervisors</p>
            </div>
          </div>
        )}
        <div className="col-lg-3 col-sm-6 mb-3">
          <div className="p-3 bg-light border rounded shadow-sm text-center">
            <h4>{dCount}</h4>
            <p>Drivers</p>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 mb-3">
          <div className="p-3 bg-light border rounded shadow-sm text-center">
            <h4>{daCount}</h4>
            <p>Attendance Drivers</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="row mb-3">
        {isAdmin && (
          <div className="col-md-3">
            <label>Supervisor</label>
            <select className="form-select" value={selSupervisor} onChange={handleSupervisorChange}>
              <option value="" disabled>
                Select
              </option>
              {supervisors.map(s => (
                <option key={s.user.id} value={s.user.id}>
                  {s.user.username}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="col-md-3">
          <label>Driver</label>
          <select
            className="form-select"
            value={selDriver}
            onChange={e => setSelDriver(e.target.value)}
          >
            <option value="">Select</option>
            {drivers.map(d => (
              <option key={d.user.id} value={d.user.id}>
                {d.user.username}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label>Date</label>
          <input
            type="date"
            className="form-control"
            value={frmDate}
            onChange={e => setFrmDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-warning w-100" onClick={getDriverAttendance}>
            VIEW
          </button>
        </div>
      </div>

      {/* Attendance Details */}
      {attendanceData && (
        <div className="card p-3 mb-4">
          <h5>Driver Attendance Details</h5>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <strong>Driver:</strong> {attendanceData?.attendance?.driver?.user?.username}
            </div>
            <div className="col-md-6">
              <strong>Emp Code:</strong> {attendanceData?.attendance?.driver?.user?.employee_code}
            </div>
            <div className="col-md-6">
              <strong>Supervisor:</strong>{' '}
              {attendanceData?.attendance?.driver?.supervisor?.user?.username}
            </div>
            <div className="col-md-6">
              <strong>Phone:</strong> {attendanceData?.attendance?.driver?.phone}
            </div>
            <div className="col-md-6">
              <strong>Email:</strong> {attendanceData?.attendance?.driver?.email}
            </div>
            <div className="col-md-6">
              <strong>Date:</strong> {attendanceData?.attendance?.date}
            </div>
            <div className="col-md-6">
              <strong>In Time:</strong>{' '}
              {attendanceData?.attendance?.online_time
                ? new Date(attendanceData?.attendance?.online_time).toLocaleString()
                : 'N/A'}
            </div>
            <div className="col-md-6">
              <strong>Out Time:</strong>{' '}
              {attendanceData?.attendance?.offline_time
                ? new Date(attendanceData?.attendance?.offline_time).toLocaleString()
                : 'N/A'}
            </div>
            <div className="col-md-6">
              <strong>Start KM:</strong> {attendanceData?.attendance?.start_km}
            </div>
            <div className="col-md-6">
              <strong>End KM:</strong> {attendanceData?.attendance?.end_km}
            </div>
            <div className="col-md-6">
              <strong>Start Time:</strong>{' '}
              {attendanceData?.attendance?.start_time
                ? new Date(attendanceData?.attendance?.start_time).toLocaleString()
                : 'N/A'}
            </div>
            <div className="col-md-6">
              <strong>End Time:</strong>{' '}
              {attendanceData?.attendance?.end_time
                ? new Date(attendanceData?.attendance?.end_time).toLocaleString()
                : 'N/A'}
            </div>
          </div>

          <div className="row mt-3 bg-light p-2 rounded">
            <div className="col-md-4">
              <strong>Total Days:</strong>{' '}
              {attendanceData?.attendance_dashboard?.total_days_in_month}
            </div>
            <div className="col-md-4">
              <strong>Present:</strong>{' '}
              {attendanceData?.attendance_dashboard?.total_attendance_days}
            </div>
            <div className="col-md-4">
              <strong>Absent:</strong> {attendanceData?.attendance_dashboard?.total_holidays_taken}
            </div>
          </div>
        </div>
      )}

      {/* Files */}
      {fileList.length > 0 && (
        <div className="card p-3">
          <h5>Driver Files</h5>
          {fileList.map((file, idx) => (
            <div key={idx} className="border p-2 rounded mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <strong>{file.filename}</strong>
                {file.url ? (
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-primary"
                  >
                    Download
                  </a>
                ) : (
                  <span className="text-danger">Not Available</span>
                )}
              </div>
              {file.url && file.url.match(/\.(jpeg|jpg|png|gif)$/) ? (
                <img
                  src={file.url}
                  alt={file.filename}
                  className="img-fluid mt-2"
                  style={{ maxHeight: 200 }}
                />
              ) : file.url && file.url.endsWith('.pdf') ? (
                <iframe
                  src={file.url}
                  width="100%"
                  height="300px"
                  className="mt-2"
                  title={file.filename}
                ></iframe>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
